import { Link } from 'react-router-dom';
import SeoHead from '@/components/feature/SeoHead';

export default function NotFound() {
  return (
    <>
      <SeoHead
        title="页面未找到 - RTB吉尔吉斯斯坦试管代孕中心"
        description="您访问的页面不存在，请返回RTB吉尔吉斯斯坦试管代孕中心首页，了解更多代孕、试管婴儿、捐卵服务。"
      />
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#f8f5f0]">
      <div className="text-6xl font-bold text-[#1a3a5c] mb-4">404</div>
      <p className="text-gray-500 mb-8">页面未找到</p>
      <Link
        to="/"
        className="bg-[#c9a96e] text-white px-6 py-2.5 rounded-full font-medium hover:bg-[#b8944f] transition-colors whitespace-nowrap cursor-pointer"
      >
        返回首页
      </Link>
      </div>
    </>
  );
}